import axios from "axios";
import { param } from "jquery";
// const  url =window.imgpath|''
// const baseurl='api'
const content = window.subPath||''
const baseurl=window.imgpath|''
// const api ='/api'
const api =''
const Qs = require('qs')

export function checkInfo(parameter) {
  let data=Qs.stringify(parameter)
    return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/checkInfo.rst?${data}`,{
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  }

  
// 发送短信验证码
  export function sendSmsCode(parameter) {
    var a = RegExp("^[0-9]*[1-9][0-9]*$")
    console.log(parameter);
    if(a.test(parameter) ){
         return axios.get(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/sendSmsCode.rst?phone=${parameter}`,{
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
    }else{
      return axios.get(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/sendSmsCode.rst`,{
      }).then(function(res){
        console.log(res.data.result.data);
        return{
          data:res.data.result.data,
          resultCode:res.data.resultCode,
          errorMsg:res.data.errorMsg
        }
      })
    }
 
  }

  //验证短信验证码
  export function checkSms(parameter = {}) {
    return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/checkSms.rst?code=${parameter.validCode}`,{
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  }
  
  //加载配置消息
  
  export function config(parameter={}){
      return axios.get(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/config.rst`,{}).then(function(res){
          console.log(res.data.result.data);
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
      })
  }

  //发送邮件验证码
  export function sendEmailCode(parameter) {
    let dataemail=Qs.stringify(parameter)
        return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/sendEmailCode.rst?${dataemail}`,{
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  }
    //验证邮箱验证码
    export function checkEmailCode(parameter = {}) {
        return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/checkEmailCode.rst?code=${parameter.validCode}`,{
        }).then(function(res){
          console.log(res.data.result.data);
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
        })
      }
    //发送微信验证码
    
    export function sendWechatCode(parameter = {}) {
        return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/sendWechatCode.rst`,{
        }).then(function(res){
          console.log(res.data.result.data);
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
        })
      }

    //  检验微信验证码
      export function checkWechatCode(parameter = {}) {
        return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/checkWechatCode.rst?code=${parameter.validCode}`,{
        }).then(function(res){
          console.log(res.data.result.data);
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
        })
      }

    //修改密码
      export function  resetPassword(parameter){
        console.log(parameter);
        // return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/resetPassword.rst?password=${parameter}`,{
          return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/forget/resetPassword.rst`,Qs.stringify(parameter),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function(res){
          console.log(res.data.result.data);
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
        })
      }
      
      //个人信息
      export function contactInfo(parameter = {}) {
        return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/forget/contactInfo.rst`,{
        }).then(function(res){
          console.log(res.data.result.data);
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
        })
      }

      //查bindemail与bindphone
      

      //密码找回成功 跳转登录页
      export function  redirectURL(parameter = {}) {
        return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/forget/redirectURL.rst`).then(function(res){
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
        })
      }
      //密保问题
      export function question(params ={}){
        return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/password/question.rst`).then(function(res){
          return{
            errorMsg:res.data.errorMsg,
            resultCode:res.data.resultCode,
            data:res.data.result.data
          }
        })
      }

      //密保问题验证
      
      export function  checkQuestion(parameter){
          return axios.post(`${api}${window.imgpath}${content}/_web/_apps/selfservice/api/password/checkQuestion.rst`,Qs.stringify(parameter),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function(res){
          return{
            data:res.data.result.data,
            resultCode:res.data.resultCode,
            errorMsg:res.data.errorMsg
          }
        })
      }